module.exports = __webpack_public_path__ + "img/Sponsored Icon - charcoal.fac57f27.svg";